import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import { catalogImportMessages } from './translations';

/**
 * Registrar existente in the v2 design (Story 5.5, AC-16): only the page
 * loader is replaced. The new page is the app's own fail-closed guard
 * (`GuardedCatalogImportPage` → `PermissionGate`, AC-30), not the stock
 * `RequirePermission`: it checks `catalogEntityCreatePermission` with
 * `usePermission` and renders the wizard only for an allowed decision
 * (nothing while loading, the check-error state on a failed check, Sem
 * permissão when denied). Presentation only: the catalog backend checks the
 * same permission, under the backend's policy, when a location is created.
 * The route stays `/catalog-import`; the title is set in app-config.yaml.
 */
export const byxCatalogImportPlugin = catalogImportPlugin.withOverrides({
  extensions: [
    catalogImportPlugin.getExtension('page:catalog-import').override({
      factory: originalFactory =>
        originalFactory({
          params: {
            loader: async () => {
              const { GuardedCatalogImportPage } = await import(
                './ByxCatalogImportPage'
              );
              return <GuardedCatalogImportPage />;
            },
          },
        }),
    }),
  ],
});

/**
 * pt-BR texts of the catalog import wizard (Story 2.3). The app's
 * translations input only accepts extensions of the app plugin itself.
 */
export const catalogImportTranslationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [catalogImportMessages],
});
